import HromadnaPripomienkaListPage from './HromadnaPripomienkaListPage';

export default HromadnaPripomienkaListPage;
